module.exports = __webpack_public_path__ + "img/CSLHSC-3.bc004355.png";